import React, { useEffect } from 'react';
import { Route, withRouter, RouteComponentProps, Redirect } from 'react-router';
import { authValidateUser } from '@redux/actions/auth.action';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { COMMON_ROUTE_PATHS } from '@constants/routes';
import { isValidUser } from '@react/utils/auth.util';
import BlankPage from '@react/components/blank/blank.component';

interface CallbackRouteState {
  isValid: boolean;
  oidcUser: any;
  isLoadingUser: boolean;
  isLoggingOut: boolean;
}

interface CallbackRouteDispatch {
  validate: (user) => void;
}

interface CallbackRouteOwnProps extends RouteComponentProps {
  path: string;
  exact?: boolean;
  component?;
  render?;
}

type CallbackRouteProps = 
  CallbackRouteState &
  CallbackRouteDispatch &
  CallbackRouteOwnProps;
 
const CallbackRoute: React.FC<CallbackRouteProps> = (props) => {
  const { isValid, validate, oidcUser, isLoadingUser, isLoggingOut } = props;
  useEffect(() => {
    if (!isLoggingOut && !isLoadingUser) {
      validate(isValidUser(oidcUser));
    } 
  }, [oidcUser, isLoadingUser]);

  if (isValid === undefined) {
    return <BlankPage />;
  }
  if (!isValid) {
    return (
      <Route
        {...props}
      />
    );
  }
  return <Redirect to={{ pathname: COMMON_ROUTE_PATHS.MAIN }} />;
};
 
const mapStateToProps = (state) => ({
  isValid: state.getIn(['Auth', 'validation', 'valid']),
  oidcUser: state.getIn(['Oidc', 'user']),
  isLoadingUser: state.getIn(['Oidc', 'isLoadingUser']),
  isLoggingOut: state.getIn(['Account', 'isLoggingOut']),
});

const mapDispatchToProps = (dispatch: any) => ({
  ...bindActionCreators(
    {
      validate: authValidateUser
    },
    dispatch
  )
});

const connected = connect<
CallbackRouteState,
CallbackRouteDispatch,
CallbackRouteOwnProps>(
  mapStateToProps,
  mapDispatchToProps
)(CallbackRoute);

export default withRouter(connected);

